<template>
  <div>

    <b-row>
      <b-col>
        <b-table-simple small>
          <b-tbody>
            <b-tr>
              <b-th class="text-left">
                <div @click.prevent="fetchData">
                  <icon name="sync-alt" :spin="isLoading"></icon>
                  {{ "Data:" }}
                </div>
              </b-th>
              <b-th class="text-left">{{ $t("globals.current") }}:</b-th>
              <b-th class="text-left">{{ $t("globals.past") }}:</b-th>
            </b-tr>
            <b-tr>
              <b-td>{{ $t("globals.new_inquiries") }}:</b-td>
              <b-td>
                <icon v-if="loading.current.inquiries" name="spinner" spin></icon>
                <div v-else-if="current.inquiries >= past.inquiries" class="text-success">
                  {{ current.inquiries }}
                </div>
                <div v-else class="text-danger">{{ current.inquiries }}</div>
              </b-td>
              <b-td>
                <icon v-if="loading.past.inquiries" name="spinner" spin></icon>
                <div v-else class="text-info">{{ past.inquiries }}</div>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ $t("globals.new_orders") }}:</b-td>
              <b-td>
                <icon v-if="loading.current.orders" name="spinner" spin></icon>
                <div v-else-if="current.orders >= past.orders" class="text-success">
                  {{ current.orders }}
                </div>
                <div v-else class="text-danger">{{ current.orders }}</div>
              </b-td>
              <b-td>
                <icon v-if="loading.past.orders" name="spinner" spin></icon>
                <div v-else class="text-info">{{ past.orders }}</div>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ $t("globals.new_customers") }}:</b-td>
              <b-td>
                <icon v-if="loading.current.customers" name="spinner" spin></icon>
                <div v-else-if="current.customers >= past.customers" class="text-success">
                  {{ current.customers }}
                </div>
                <div v-else class="text-danger">{{ current.customers }}</div>
              </b-td>
              <b-td>
                <icon v-if="loading.past.customers" name="spinner" spin></icon>
                <div v-else class="text-info">{{ past.customers }}</div>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ $t("globals.sold_devices") }}:</b-td>
              <b-td>
                <icon v-if="loading.current.devices" name="spinner" spin></icon>
                <div v-else-if="current.devices >= past.devices" class="text-success">
                  {{ current.devices }}
                </div>
                <div v-else class="text-danger">{{ current.devices }}</div>
              </b-td>
              <b-td>
                <icon v-if="loading.past.devices" name="spinner" spin></icon>
                <div v-else class="text-info">{{ past.devices }}</div>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ $t("globals.invoices_sent") }}:</b-td>
              <b-td>
                <icon v-if="loading.current.invoices" name="spinner" spin></icon>
                <div v-else-if="current.invoices >= past.invoices" class="text-success">
                  {{ current.invoices }}
                </div>
                <div v-else class="text-danger">{{ current.invoices }}</div>
              </b-td>
              <b-td>
                <icon v-if="loading.past.invoices" name="spinner" spin></icon>
                <div v-else class="text-info">{{ past.invoices }}</div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import "vue-awesome/icons/spinner";
import "vue-awesome/icons/sync-alt";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue")
  },
  props: {
    currentRange: Array,
    pastRange: Array
  },
  data() {
    return {
      tabIndex: 2,
      current: {
        orders: 0,
        devices: 0,
        invoices: 0,
        inquiries: 0,
        customers: 0
      },
      past: {
        orders: 0,
        devices: 0,
        invoices: 0,
        inquiries: 0,
        customers: 0
      },
      loading: {
        current: {
          inquiries: false,
          orders: false,
          invoices: false,
          devices: false,
          customers: false
        },
        past: {
          inquiries: false,
          orders: false,
          invoices: false,
          devices: false,
          customers: false
        }
      }
    };
  },
  methods: {
    ...mapActions([
      "fetchSoldDevicesForRange",
      "fetchSentInvoicesForRange",
      "fetchInquiriesCreatedForRange",
      "fetchOrdersCreatedForRange",
      "fetchCustomersCreatedForRange"
    ]),
    fetchDevices() {
      this.loading.current.devices = true;
      this.loading.past.devices = true;

      this.fetchSoldDevicesForRange(this.currentRange)
        .then(res => {
          this.current.devices = res.data.data.soldDevicesForRange;
        })
        .finally(() => {
          this.loading.current.devices = false;
        });

      this.fetchSoldDevicesForRange(this.pastRange)
        .then(res => {
          this.past.devices = res.data.data.soldDevicesForRange;
        })
        .finally(() => {
          this.loading.past.devices = false;
        });
    },
    fetchInvoices() {
      this.loading.current.invoices = true;
      this.loading.past.invoices = true;

      this.fetchSentInvoicesForRange(this.currentRange)
        .then(res => {
          this.current.invoices = res.data.data.invoicesSentForRange;
        })
        .finally(() => {
          this.loading.current.invoices = false;
        });

      this.fetchSentInvoicesForRange(this.pastRange)
        .then(res => {
          this.past.invoices = res.data.data.invoicesSentForRange;
        })
        .finally(() => {
          this.loading.past.invoices = false;
        });
    },
    fetchInquiries() {
      this.loading.current.inquiries = true;
      this.loading.past.inquiries = true;

      this.fetchInquiriesCreatedForRange(this.currentRange)
        .then(res => {
          this.current.inquiries = res.data.data.inquiriesCreatedForRange;
        })
        .finally(() => {
          this.loading.current.inquiries = false;
        });

      this.fetchInquiriesCreatedForRange(this.pastRange)
        .then(res => {
          this.past.inquiries = res.data.data.inquiriesCreatedForRange;
        })
        .finally(() => {
          this.loading.past.inquiries = false;
        });
    },
    fetchOrders() {
      this.loading.current.orders = true;
      this.loading.past.orders = true;

      this.fetchOrdersCreatedForRange(this.currentRange)
        .then(res => {
          this.current.orders = res.data.data.ordersCreatedForRange;
        })
        .finally(() => {
          this.loading.current.orders = false;
        });

      this.fetchOrdersCreatedForRange(this.pastRange)
        .then(res => {
          this.past.orders = res.data.data.ordersCreatedForRange;
        })
        .finally(() => {
          this.loading.past.orders = false;
        });
    },
    fetchCustomers() {
      this.loading.current.customers = true;
      this.loading.past.customers = true;

      this.fetchCustomersCreatedForRange({ range: this.currentRange })
        .then(res => {
          this.current.customers = res.data.data.noCustomersForRange;
        })
        .finally(() => {
          this.loading.current.customers = false;
        });

      this.fetchCustomersCreatedForRange({ range: this.pastRange })
        .then(res => {
          this.past.customers = res.data.data.noCustomersForRange;
        })
        .finally(() => {
          this.loading.past.customers = false;
        });
    },
    fetchData() {
      this.fetchDevices();
      this.fetchCustomers();
      this.fetchInvoices();
      this.fetchInquiries();
      this.fetchOrders();
    }
  },
  computed: {
    ...mapGetters(["getUserSystem"]),
    isLoading() {
      return (
        this.loading.current.inquiries &&
        this.loading.current.orders &&
        this.loading.current.invoices &&
        this.loading.current.devices &&
        this.loading.current.customers &&
        this.loading.past.inquiries &&
        this.loading.past.orders &&
        this.loading.past.invoices &&
        this.loading.past.customers &&
        this.loading.past.devices
      );
    }
  },
  watch: {
    getUserSystem: function() {
      this.fetchData();
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
